"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../Utils");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = require("styled-components");
var _recharts = require("recharts");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LineChart = _ref => {
  let {
    completeTooltip = true,
    config = [],
    data = [],
    disabled = false,
    fontSize = "12px",
    height = 400,
    legend = false,
    minHeight,
    minWidth,
    width = "100%",
    onClick,
    selected,
    tickFormatter = value => value,
    tooltip = true,
    type = 'category',
    xPosition = 'bottom',
    yPosition = 'left',
    yReversed = false,
    yTicks
  } = _ref;
  const {
    primaryColor,
    primaryLighterColor,
    textColor
  } = (0, _styledComponents.useTheme)();
  const getIndex = key => config.findIndex(_ref2 => {
    let {
      dataKey
    } = _ref2;
    return dataKey === key;
  });
  const getLabel = key => {
    var _config$find$label, _config$find;
    return (_config$find$label = (_config$find = config.find(_ref3 => {
      let {
        dataKey
      } = _ref3;
      return dataKey === key;
    })) === null || _config$find === void 0 ? void 0 : _config$find.label) !== null && _config$find$label !== void 0 ? _config$find$label : key;
  };
  const CustomTooltip = _ref4 => {
    let {
      active,
      payload
    } = _ref4;
    if (!active || (0, _isEmpty.default)(payload) || (0, _isEmpty.default)(config)) return null;
    const {
      payload: dataPayload
    } = payload[0];
    if (config.length === 1) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.TooltipContainer, {
        tabIndex: "-1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipValue, {
          margin: "0px",
          children: [dataPayload.label, ": ", getLabel(dataPayload[config[0].dataKey])]
        })
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipContainer, {
      tabIndex: "-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.TooltipLabel, {
        children: dataPayload.label
      }), config.map(_ref5 => {
        let {
          dataKey
        } = _ref5;
        if (!completeTooltip && dataPayload[dataKey] === undefined) return null;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TooltipValue, {
          margin: "5px 0px 0px 0px",
          children: [getLabel(dataKey), ": ", dataPayload[dataKey]]
        }, dataKey);
      })]
    });
  };
  const legendFormatter = (_, _ref6) => {
    let {
      dataKey
    } = _ref6;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.LegendSpan, {
      children: getLabel(dataKey)
    });
  };
  const handleClick = (key, index) => {
    if (!onClick || disabled) return;
    onClick({
      index,
      key,
      source: 'line'
    });
  };
  const handleLegendClick = (_ref7, index) => {
    let {
      dataKey: key
    } = _ref7;
    if (!onClick || disabled) return;
    onClick({
      index,
      key,
      source: 'legend'
    });
  };
  const axisStyles = {
    tick: {
      fill: textColor,
      fontSize
    }
  };
  const chartProps = {
    data,
    margin: '0px',
    opacity: disabled ? 0.4 : 1
  };
  const containerProps = {
    height,
    minHeight,
    minWidth,
    width
  };
  const gridStyle = {
    stroke: primaryLighterColor
  };
  const legendStyle = {
    cursor: onClick && !disabled ? 'pointer' : 'default'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ResponsiveContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    selectedIndex: selected ? getIndex(selected) : undefined,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_recharts.LineChart, _objectSpread(_objectSpread({}, chartProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.CartesianGrid, {
        style: gridStyle
      }), config.map((_ref8, index) => {
        let {
          dataKey,
          dot,
          stroke,
          strokeWidth = 2,
          type = "monotone"
        } = _ref8;
        const isSelected = selected === dataKey;
        const lineStroke = stroke !== null && stroke !== void 0 ? stroke : (0, _Utils.getDefaultColor)(index, primaryColor);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Line, {
          animationDuration: 600,
          cursor: onClick && !disabled ? 'pointer' : 'cursor',
          dataKey: dataKey,
          dot: dot,
          opacity: selected && !isSelected ? 0.5 : 1,
          stroke: lineStroke,
          strokeWidth: isSelected ? 3 : strokeWidth,
          type: type,
          onClick: () => handleClick(dataKey, index)
        }, index);
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.XAxis, _objectSpread(_objectSpread({}, axisStyles), {}, {
        dataKey: "label",
        interval: 0,
        orientation: xPosition,
        type: type
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.YAxis, _objectSpread(_objectSpread({}, axisStyles), {}, {
        orientation: yPosition,
        reversed: yReversed,
        tickFormatter: tickFormatter,
        ticks: yTicks,
        type: "number",
        width: 40
      })), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Tooltip, {
        content: CustomTooltip,
        cursor: {
          fill: 'transparent'
        },
        wrapperStyle: {
          outline: 'none'
        }
      }), legend && /*#__PURE__*/(0, _jsxRuntime.jsx)(_recharts.Legend, {
        formatter: legendFormatter,
        wrapperStyle: legendStyle,
        onClick: handleLegendClick
      })]
    }))
  }));
};
LineChart.propTypes = {
  completeTooltip: _propTypes.default.bool,
  config: _propTypes.default.arrayOf(_propTypes.default.shape({
    dataKey: _propTypes.default.string.isRequired,
    dot: _propTypes.default.shape({
      fill: _propTypes.default.string,
      stroke: _propTypes.default.string,
      strokeWidth: _propTypes.default.number
    }),
    label: _propTypes.default.string.isRequired,
    stroke: _propTypes.default.string,
    strokeWidth: _propTypes.default.number,
    type: _propTypes.default.string
  })),
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    label: _propTypes.default.string.isRequired
  })),
  disabled: _propTypes.default.bool,
  fontSize: _propTypes.default.string,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  legend: _propTypes.default.bool,
  minHeight: _propTypes.default.number,
  minWidth: _propTypes.default.number,
  onClick: _propTypes.default.func,
  selected: _propTypes.default.string,
  stacked: _propTypes.default.bool,
  tickFormatter: _propTypes.default.func,
  tooltip: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['category', 'number']),
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  xPosition: _propTypes.default.oneOf(['bottom', 'top']),
  yPosition: _propTypes.default.oneOf(['left', 'right']),
  yReversed: _propTypes.default.bool,
  yTicks: _propTypes.default.arrayOf(_propTypes.default.number)
};
var _default = exports.default = LineChart;